export const DbConfig = (DbDataObjects) => {
  const config = {
    name: "RashenDb",
    version: 1,
    objectStoresMeta: [
      {
        store: "people",
        storeConfig: { keyPath: "id", autoIncrement: true },
        storeSchema: [
          { name: "name", keypath: "name", options: { unique: false } },
          { name: "email", keypath: "email", options: { unique: false } },
        ],
      },
    ],
  };
  return config;
};
